import { ActionRetry } from 'common/components/monochrome-icons';
import { Button } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Styles } from './retry-button.styles';

export const RetryButton: React.FC<React.HTMLAttributes<HTMLElement>> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div className={Styles.retryButtonContainer}>
      <Button
        onClick={onClick}
        className={Styles.retryButton}
        kind="regular"
        rounded
        size="l"
        variant="secondary"
        iconOnly
        aria-label={t('ui.buttons.retry')}
      >
        <ActionRetry className={Styles.retryButtonIcon} />
      </Button>
    </div>
  );
};
